import { apiRequest } from '../../api/client';

export async function getSpecialAccessInviteByToken(token) {
  return apiRequest(`/api/public/special-access-invites/${encodeURIComponent(token)}`);
}

export async function acceptSpecialAccessInvite({ token, idToken, firstName, lastName, companyName }) {
  return apiRequest(`/api/special-access-invites/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
    token: idToken,
    body: { firstName, lastName, companyName },
  });
}
